<template>
  <div>
    <!-- ヘッダ -->
    <comHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="companyname"></comHeaderAuth>
    <!-- メイン -->
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="warning" elevation="2">
          {{ messageArea }}
        </v-alert>
        <br/>
        
        <template>
          <v-stepper v-model="nowStepNo" class="pa-0" min-height="70%">
            <v-stepper-header>
              <v-stepper-step step="1" :complete="isCompletedStep1" editable edit-icon="mdi-hand-okay">
                <small>step 1</small>{{stepAbbrName1}}
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2" :complete="isCompletedStep2" editable edit-icon="mdi-hand-okay">
                <small>step 2</small>{{stepAbbrName2}}
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3" :complete="isCompletedStep3" editable edit-icon="mdi-hand-okay">
                <small>step 3</small>{{stepAbbrName3}}
              </v-stepper-step>
              <!-- <v-divider></v-divider>
              <v-stepper-step step="4" :complete="isCompletedStep4" editable edit-icon="mdi-hand-okay">
                <small>step 4</small>{{stepAbbrName4}}
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="5" :complete="isCompletedStep5" editable edit-icon="mdi-hand-okay">
                <small>step 5</small>{{stepAbbrName5}}
              </v-stepper-step> -->
            </v-stepper-header>
            <v-stepper-items >
              <v-stepper-content step="1" style="height: 100%;">
                <v-card :height="priceViewHeight">
                <small>step 1</small><p>{{stepName1}}</p>
                <v-card color="grey lighten-3" flat>
                  <v-card-subtitle>
                    <v-row>
                      <v-col cols="12" sm="6">
                      <label class="required">選択ボタンをクリックして、お申込みのプランを選択してください </label>
                      </v-col>
                      <v-col cols="12" sm="6" class="d-flex align-center justify-end">
                        <v-row>
                          <v-col cols="12" class="d-flex align-center justify-end px-0">
                          <v-btn elevation="4" color="warning" class="white--text mr-3 mb-1" @click="dispSelectPlanScreen()">選択</v-btn>
                          <v-btn elevation="4" color="warning" class="white--text mr-2 mb-1" @click="clearSelectedPlan()">クリア</v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-subtitle>
                  <v-card-text class="px-1 px-sm-4">
                          
                      <v-simple-table class="py-4 px-0 px-sm-1 px-md-16 px-xl-16">
                        <thead>
                          <tr>
                            <th class="text-center" style="width:53%">プラン名</th>
                            <th class="text-center" style="width:10%"></th>
                            <th class="text-center">報酬額</th>
                            <th class="text-center px-0">登録免許税又は印紙税等</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in planDesserts" :key="item.planName" style="background-color: white !important;" >
                            <template v-if="item.planName === '小計'" >
                              <td class="" style="background-color: #ffffff;border:0;"></td>
                              <td class="text-right text-caption text-sm-body-1 text-md-body-1" style="background-color: #BDBDBD;">
                                {{ item.planName }}
                              </td>
                              <td class="text-right px-0 text-caption text-sm-body-1" style="background-color: #F5F5F5;">
                                <template v-if="Number(item.planReward) > 0">{{ item.planReward.toLocaleString() }}円</template>
                                <template v-else></template>
                              </td>
                              <td class="text-right pr-2 text-caption text-sm-body-1" style="background-color: #F5F5F5;">
                                <template v-if="Number(item.planTax) > 0">{{ item.planTax.toLocaleString() }}円</template>
                                <template v-else></template>  
                              </td>
                            </template>
                            <template v-else-if="item.planName === '合計'  || item.planName === '消費税10%'  || item.planName === '請求金額'" >
                              <td class="" style="background-color: #ffffff;border:0;"></td>
                              <td class="text-right text-caption text-sm-body-1 text-md-body-1" style="background-color: #BDBDBD;">
                                {{ item.planName }}
                              </td>
                              <td class="" style="background-color: #F5F5F5;"></td>
                              <td class="text-right px-2 text-caption text-sm-body-1" style="background-color: #F5F5F5;">
                                <template v-if="Number(item.planReward) > 0">{{ item.planReward.toLocaleString() }}円</template>
                                <template v-else></template>
                              </td>
                            </template>
                            <template v-else>
                              <td class="text-left text-caption text-sm-body-1 text-md-subtitle-1" style="background-color: #F5F5F5;">{{ item.planName }}</td>
                              <td class="" style="background-color: #ffffff;;"></td>
                              <td class="text-right px-0 text-caption text-sm-body-1" >
                                <template v-if="Number(item.planReward) >= 0">{{ item.planReward.toLocaleString() }}円</template>
                                <template v-else></template>
                              </td>
                              <td class="text-right pr-2 text-caption text-sm-body-1">
                                <template v-if="Number(item.planTax) > 0">{{ item.planTax.toLocaleString() }}円</template>
                                <template v-else></template>  
                              </td>
                            </template>
                          </tr>
                        </tbody>
                      </v-simple-table>
                  </v-card-text>
                  <v-card-actions class="d-flex align-center justify-end" style="background-color: white !important;">
                    <!-- <v-btn elevation="4" color="warning" class="white--text" @click="dispSelectPlanScreen()">選択</v-btn>
                    <v-btn elevation="4" color="warning" class="white--text left-margin" @click="clearSelectedPlan()">クリア</v-btn> -->
                  </v-card-actions>

                </v-card>
                  <v-card-actions class="d-flex align-center justify-center" style="background-color: white !important;">
                    <v-btn color="primary" @click="nowStepNo = 2">
                      step2<v-icon left>mdi-arrow-right-thick</v-icon> 
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>

              <!-- <v-stepper-content step="2" style="height: 100%;">
                <v-card height="56vh">
                <small>step 2</small><p>{{stepName2}}</p>
                <v-card color="grey lighten-3" flat>
                  <v-card-subtitle>
                    <label>選択ボタンをクリックして登記情報提供サービスのPDFファイルを選択してください </label>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row style="background-color: white !important;">
                      <v-col cols="12" class="d-flex align-center justify-start" >
                        <v-file-input @click="handleClickAppendProcess()" @change="changeFileInfo($event)" @click:clear="clearFileInfo()" outlined dense  accept=".pdf" class="file-input" ref="vFileInput" prepend-icon="" height="4" :truncate-length="filenameLngth" v-model="fileData">
                          <template v-slot:append-outer>
                            <div @click="handleClickAppendOuter()">
                              <v-btn elevation="4" color="warning" class="sentaku-btn2 white--text">選択</v-btn>
                            </div>
                          </template>
                        </v-file-input>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions class="d-flex align-center justify-center" style="background-color: white !important;">
                    <v-btn class="mr-10 mt-5" color="primary" @click="nowStepNo = 1">
                      <v-icon left>mdi-arrow-left-thick</v-icon> step1
                    </v-btn>
                    <v-btn class="mr-10 mt-5" color="primary" @click="nowStepNo = 3">
                      step3<v-icon left>mdi-arrow-right-thick</v-icon> 
                    </v-btn>
                  </v-card-actions>
                </v-card>
                </v-card>
              </v-stepper-content> -->
              
              <v-stepper-content step="2" style="height: 100%;">
                <v-card height="56vh">
                <small>step 2</small><p>{{stepName2}}</p>
                <v-card color="grey lighten-3" flat>
                  <v-card-subtitle>
                    <v-row>
                      <v-col cols="12" md="4" class="d-flex align-center justify-start">
                        <label class="required">役員変更の内容に該当するボタンをクリックして役員変更情報を入力してください </label>
                      </v-col>
                      <template v-if="officerChgAReq">
                        <v-col cols="12" md="4" class="d-flex align-center justify-center">
                          <v-btn elevation="10" color="warning" class="white--text" min-width="260px" @click="changeOfficerAppoint()">就任・重任(再任)</v-btn>
                        </v-col>
                        <v-col cols="12" md="4" class="d-flex align-center justify-center">
                          <v-btn elevation="10" color="warning" class="white--text" min-width="260px" @click="changeOfficerResign()">辞任・任期満了退任・解任・死亡</v-btn>
                        </v-col>
                      </template>
                      <template v-else-if="addressChgReq">
                        <v-col cols="12" md="4" class="d-flex align-center justify-center">
                          <v-btn elevation="10" color="warning" class="white--text" min-width="260px" @click="changeOfficerAddress()">代表者住所変更</v-btn>
                        </v-col>
                        <v-col cols="12" md="4"></v-col>
                      </template>
                      <template v-else>
                        <v-col cols="12" md="8" class="d-flex align-center justify-center px-0">
                          <span class="red--text text-subtitle-1"> プランを選択していないため役員変更の入力ができません。<br/></span>
                        </v-col>
                      </template>
                    </v-row>
                </v-card-subtitle>
                <!-- <v-card-text>
                  <v-row style="background-color: white !important;">
                    <v-col cols="12" class="d-flex align-center justify-center" >
                      <v-btn elevation="4" color="warning" class="white--text" @click="changeOfficerInfo()">役員変更入力</v-btn>
                    </v-col>
                  </v-row>
                  </v-card-text> -->
                  <v-card-actions class="d-flex align-center justify-center" style="background-color: white !important;">
                    <v-btn class="mr-10 mt-5" color="primary" @click="nowStepNo = 1">
                      <v-icon left>mdi-arrow-left-thick</v-icon> step1
                    </v-btn>
                    <v-btn class="ml-10 mt-5" color="primary" @click="nowStepNo = 3">
                      step3<v-icon left>mdi-arrow-right-thick</v-icon> 
                    </v-btn>
                  </v-card-actions>
                </v-card>
                </v-card>
              </v-stepper-content>

              <!-- <v-stepper-content step="4" style="height: 100%;">
                <v-card :height="regDetailViewHeight">
                <small>step 4</small><p>{{stepName4}}</p>
                <v-card color="grey lighten-3" flat>
                  <v-card-subtitle class="mb-0">
                    <label class="required">雛形を利用して登記変更の詳細を入力してください </label>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row style="background-color: white !important;">
                      <v-col cols="12" class="d-flex align-center justify-center pb-0">
                        <v-textarea flat dense solo v-model="comregDetail" rows="10" overflow="scroll" background-color="indigo lighten-5" @blur="setRegDetailInfo($event)" class="text-sm-button text-md-body-2 text-lg-body-2 text-xl-body-1"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions class="d-flex align-center justify-center" style="background-color: white !important;">
                    <v-btn class="mr-10 mt-5" color="primary" @click="nowStepNo = 3">
                      <v-icon left>mdi-arrow-left-thick</v-icon> step3
                    </v-btn>
                    <v-btn class="mr-10 mt-5" color="primary" @click="nowStepNo = 5">
                      step5<v-icon left>mdi-arrow-right-thick</v-icon> 
                    </v-btn>
                  </v-card-actions>
                </v-card>
                </v-card>
              </v-stepper-content> -->

              <v-stepper-content step="3" style="height: 100%;">
                <v-card :height="requestConfirmViewHeight">
                <small>step 3</small><p>{{stepName3}}</p>
                <v-card flat>
                  <v-card-text >  
                    <v-row >
                      <v-col cols="12" class="d-flex align-center justify-center">
                        <v-btn elevation="4" x-large color="warning" min-width="200px" class="kakutei" @click="confirmRequest()">お申込み内容確認</v-btn>
                      </v-col>
                    </v-row>
                    <v-row class="pa-2">
                      <v-col cols="3" sm="6" class="d-flex align-center justify-center ">
                        <v-card class="ml-auto" max-width="100px" color="transparent" flat>
                          <v-img src="../assets/img/tqsman-big.png"></v-img>
                        </v-card>
                      </v-col>
                      <v-col cols="9" sm="6" lg="4" class="d-flex align-center justify-center">
                        <p class="speech-bg text-caption text-sm-h6">こちらのボタンをクリックし、申込み内容を確認してください。<br />申込みが終了するまで、もう少しです。</p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions class="d-flex align-center justify-center mt-2" style="background-color: white !important;">
                    <v-btn color="primary" @click="nowStepNo = 2">
                      <v-icon left>mdi-arrow-left-thick</v-icon> step2
                    </v-btn>
                  </v-card-actions>
                </v-card>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </template>

        <br />
        <!-- ボタンエリア -->
        <v-row>
          <v-col cols="12" class="d-flex align-center justify-start">
            <v-btn x-large  color="warning" dark min-width="100px" @click="cancel()">キャンセル</v-btn>
          </v-col>
        </v-row>

        <comSelectPlan :isOpen="planDlg.isOpen" :doYes="planDlg.doYes" :doNo="planDlg.doNo" :isClear="planDlg.isClear"></comSelectPlan>
        <comInputOfficerInfo :isOpen="officerAppointDlg.isOpen" :doYes="officerAppointDlg.doYes" :doNo="officerAppointDlg.doNo" :propInputTyp="officerAppointDlg.inputTyp"></comInputOfficerInfo>
        <comInputOfficerInfo :isOpen="officerResignDlg.isOpen" :doYes="officerResignDlg.doYes" :doNo="officerResignDlg.doNo" :propInputTyp="officerResignDlg.inputTyp"></comInputOfficerInfo>
        <comInputOfficerInfo :isOpen="officerAddressDlg.isOpen" :doYes="officerAddressDlg.doYes" :doNo="officerAddressDlg.doNo" :propInputTyp="officerAddressDlg.inputTyp"></comInputOfficerInfo>
        <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
        <comMessageConfirm :msg="dlgMsgCanel.msg" :isOpen="dlgMsgCanel.isOpen" :doYes="dlgMsgCanel.doYes" :doNo="dlgMsgCanel.doNo"/>
        <comMessage :msg="dlgMsgAPIErr.msg" :isOpen="dlgMsgAPIErr.isOpen" :doYes="dlgMsgAPIErr.doYes"/>
      </v-container>
    </v-main>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import Constants from "../common/constants";
import Utils from "../common/utils";
export default {
  name: "InputRequestHome",
  // props: ["srcViewId", "requestId"],
  computed: {
    // // ★ストアのゲッターをローカルの算出プロパティにマッピング
    // ...mapGetters("requestRegInfo", ["getSelectedPlanIdList"]),
    // ...mapGetters("master", ["getPlanMstList"]),
    priceViewHeight() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        return "90h";
      } else if (bp == 'md' || bp == 'sm') {
        return "76vh";
      } else if (bp == 'lg' || bp == 'xl') {
        return "70vh";
      } else {
        return "52vh";
      }
    },
    filenameLngth() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        return "7";
      } else if (bp == 'sm') {
        return "22";
      } else if (bp == 'md' || bp == 'lg' || bp == 'xl') {
        return "100";
      } else {
        return "200";
      } 
    },
    regDetailViewHeight() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        return "85vh";
      } else if (bp == 'md' || bp == 'sm') {
        return "60vh";
      } else if (bp == 'lg' || bp == 'xl') {
        return "60vh";
      } else {
        return "52vh";
      }
    },
    requestConfirmViewHeight() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        return "65vh";
      } else if (bp == 'md' || bp == 'sm') {
        return "60vh";
      } else if (bp == 'lg' || bp == 'xl') {
        return "60vh";
      } else {
        return "52vh";
      }
    }
  },

  data() {
    return {
      username: "",
      companyname: "",
      screenTitle: "お申込み内容入力",
      screenId: "MBR400",
      messageArea: "",
      planMstList: [],
      comregDetailDef: "",
      comregDetail: "",
      // stepAbbrName1: "プラン",
      // stepAbbrName2: "登記ファイル",
      // stepAbbrName3: "役員変更",
      // stepAbbrName4: "登記変更詳細",
      // stepAbbrName5: "お申込み内容確認",
      // stepName1: "お申込みプラン",
      // stepName2: "登記提供情報ファイル",
      // stepName3: "役員変更登記",
      // stepName4: "登記変更詳細",
      // stepName5: "お申込み内容確認",
      // isCompletedStep1: false,
      // isCompletedStep2: false,
      // isCompletedStep3: false,
      // isCompletedStep4: false,
      // isCompletedStep5: false,

      stepAbbrName1: "プラン",
      stepAbbrName2: "役員変更",
      stepAbbrName3: "お申込み内容確認",
      stepName1: "お申込みプラン",
      stepName2: "役員変更登記",
      stepName3: "お申込み内容確認",

      nowStepNo: 1,
      officerChgAReq: false,
      addressChgReq: false,
      isCompletedStep1: false,
      isCompletedStep2: false,
      isCompletedStep3: false,
      // searchPlanKihonNm: "",
      // searchPlanOptionNm: "",
      // dispPlanIdNm: "",
      totalAmount: "",
      fileData: null,
      // planHeaders: [
      //     { text: 'プラン', align: 'center', sortable: true, value: 'planName', width: "20%" },
      //     { text: '報酬額', align: 'center', sortable: true, value: 'planReward', width: "10%" },
      //     { text: '登録免許税又は印紙税等', align: 'center', sortable: true, value: 'planTax', width: "10%" },
          
      // ],
      planDesserts: [],
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dlgMsgCanel: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.clearStoreForEditStartOutMixin();

          this.dlgMsgCanel.isOpen = false;
          // 会員ホームへ遷移
          this.$router.push(this.$router.resolve({ name: "MBR100" }).href);
        },
        doNo: () => {
          this.dlgMsgCanel.isOpen = false;
        },
      },
      planDlg: {
        isOpen: false,
        isClear: false,
        doYes: () => {
          // 選択プランIDリスト取得(ストア)
          //let selectedPlanIdList = this.$store.getters["requestRegInfo/getSelectedPlanIdList"];
          // 表示用申込プラン情報生成
          this.planDlg.isOpen = false;
          this.planDlg.isClear = false;
          this.dispSelectedPlanNames();
        },
        doNo: () => {
          // 処理なし
          this.planDlg.isOpen = false;
          this.planDlg.isClear = false;
        },
      },
      officerAppointDlg: {
        isOpen: false,
        inputTyp: "",
        doYes: () => {
          this.officerAppointDlg.isOpen = false;
          // 役員情報有無チェック
          this.checkOfficerInfo();
        },
        doNo: () => {
          // 処理なし
          this.officerAppointDlg.isOpen = false;
        },
      },
      officerResignDlg: {
        isOpen: false,
        inputTyp: "",
        doYes: () => {
          this.officerResignDlg.isOpen = false;
          // 役員情報有無チェック
          this.checkOfficerInfo();
        },
        doNo: () => {
          // 処理なし
          this.officerResignDlg.isOpen = false;
        },
      },
      officerAddressDlg: {
        isOpen: false,
        inputTyp: "",
        doYes: () => {
          this.officerAddressDlg.isOpen = false;
          // 役員情報有無チェック
          this.checkOfficerInfo();
        },
        doNo: () => {
          // 処理なし
          this.officerAddressDlg.isOpen = false;
        },
      },
      dlgMsgAPIErr: {
        msg: "",
        isOpen: false,
        doYes: () => {
          // this.setScreenLeaveFlgOnMixin();
          this.dlgMsgAPIErr.isOpen = false;
          // ストアクリア
          this.$store.commit("requestRegInfo/resetState");
          // 会員ホームへ遷移
          this.$router.push(this.$router.resolve({ name: "MBR100" }).href);
        },
      },
      fileInfo: [{ name: "", size: "", lastModified: "" }],
    };
  },

  created() {
    this.initialize();
  },
  mounted() {
    // window.addEventListener('beforeunload', this.onLeave);
  },
  beforeDestroy() {
    // window.removeEventListener('beforeunload', this.onLeave);
  },
  // beforeRouteLeave (to, from, next) {
  //   if (this.getScreenLeaveFlgMixin()) {
  //     next();
  //   } else {
  //     if (window.confirm('入力内容が保存されない可能性があります。ページを離れますか？')) {
  //       console.log("[LEAVE] To: " + to.path, + " From: " + from.path);
  //       next();
  //     } else {
  //       next(false);
  //     }
  //   }
  // },
  methods: {

    // **********************************
    //  初期表示処理
    // **********************************
    initialize: function() {
      // this.setScreenLeaveFlgOffMixin();
      this.setAuthUserInfo();
      this.messageArea = this.$i18n.t('webmsg.mbr400.area');
      // 初期表示情報取得・表示
      this.dispInitializeInfo();
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setLoginInfoMixin();
      this.username = authInfo['username'];
      this.companyname = authInfo['companyname'];
    },
    /*
    * 画面表示用データの生成(申込編集用情報)
    * データストアデータを表示用データへ編集
    */
    dispInitializeInfo: async function() {
      // サービス呼び出し
      let apiurl = Constants.URL_API_MBR400G01;
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        // 
        let responseDto = response.data;
        let result = this.setInitializeInfo(responseDto);
        if (!result) {
          this.dlgMsgAPIErr.msg = responseDto.message;
          this.dlgMsgAPIErr.isOpen = true;
        }
      } catch(error) {   
          this.dlgMsgAPIErr.msg = this.$i18n.t('msg.err.cm100', ['お申込み内容入力画面']);
          this.dlgMsgAPIErr.isOpen = true;
      }
    },
    /*
    * 画面表示用データストアデータ登録
    * 画面表示用データのデータストアデータへ登録
    */
    setInitializeInfo: function(responseDto) {
      let retVal = false;
      if (responseDto == null) {
        return retVal;
      }
      let responseStatus = responseDto.statusCd;
      if (responseStatus !== 200) {
        return retVal;
      }
      retVal = true;
      // ストアデータ
      // プラン情報
      this.$store.dispatch("master/setPlanMstList", responseDto.data.planList);
      this.$store.dispatch("master/setDisplayPlanList", responseDto.data.displayPlanList);
      // 消費税率区分情報s
      this.$store.dispatch("master/setTaxRateKbn", responseDto.data.taxRateKbnInfo);
      // 役員変更選択プルダウン
      this.$store.dispatch("master/setChangeOfficerKbnList", responseDto.data.changeOfficerPullDown);
      this.$store.dispatch("master/setChangeOfficerKbnAppointList", responseDto.data.changeOfficerAppointPullDown);
      this.$store.dispatch("master/setChangeOfficerKbnResignList", responseDto.data.changeOfficerResignPullDown);
      this.$store.dispatch("master/setChangeOfficerKbnOthersList", responseDto.data.changeOfficerOthersPullDown);
      // 資格選択プルダウン
      this.$store.dispatch("master/setOfficerKbnList", responseDto.data.officerPullDown);
      // 登記変更詳細(基本)情報
      // this.$store.dispatch("master/setBaseChangeDetail", responseDto.data.baseChangeDetail);
      // 登記変更詳細(役員変更区分毎)情報
      this.$store.dispatch("master/setChangeOfficerDetailList", responseDto.data.changeDetailMap);
      // 画面設定
      this.planMstList = responseDto.data.planList;
      this.comregDetailDef = responseDto.data.baseChangeDetail;
      this.comregDetail = responseDto.data.baseChangeDetail;
      // this.clearFileInfo()

      // 編集状態取得
      let editStatus = this.$store.getters["requestRegInfo/getEditStatus"];

      /** 依頼入力前(0)または申込後(3) */
      if (editStatus == Constants.EDIT_STATUS_BEFORE_INPUT || editStatus == Constants.EDIT_STATUS_REQUEST) {
        // ストアクリア
        this.$store.commit("requestRegInfo/resetState");
        // 編集状態(編集中)ストア登録
        this.$store.dispatch("requestRegInfo/setEditStatus", Constants.EDIT_STATUS_INPUT);
        return retVal;
      }
      /** 依頼入力中(1)または確定状態(2) */
      if (editStatus == Constants.EDIT_STATUS_INPUT || editStatus == Constants.EDIT_STATUS_CONFIRM) {
        // 編集状態(編集中)ストア登録
        this.$store.dispatch("requestRegInfo/setEditStatus", Constants.EDIT_STATUS_INPUT);
        // 申込み中(入力中)データの表示(ストア表示)
        this.dispInputData();
      }
      return retVal;
    },
    /*
    * 画面表示用データの生成(申込中情報)
    * データストアデータを表示用データへ編集
    */
    dispInputData: function() {
      // プラン情報表示(ステップ完了状態, データ)
      this.dispSelectedPlanNames();
      // // 登記ファイル情報表示(初期化)
      // this.changeFileInfo();
      // 役員変更入力情報表示(ステップ完了状態)
      this.checkOfficerInfo();
      // // 記変更詳細情報表示(ステップ完了状態, データ)
      // this.comregDetail = this.$store.getters["requestRegInfo/getRegChgInfoInput"];
      // if (this.comregDetail == "") {
      //   this.comregDetail = this.comregDetailDef;
      // }
      // // ステップ完了状態（登記変更詳細情報）設定
      // if (this.comregDetail == this.comregDetailDef || this.comregDetail == "") {
      //   // 未完
      //   this.isCompletedStep4 = false;
      // } else {
      //   // 完了
      //   this.isCompletedStep4 = true;
      // }
    },
    // **********************************
    //  プラン（ステップ1）
    // **********************************
    /**
     * 「プラン選択」ボタン押下
     */
    dispSelectPlanScreen: function() {
      //プラン選択画面表示
      this.planDlg.isOpen = true;
      // ステップ完了状態（役員変更）初期化
      this.isCompletedStep2 = false;
      this.clearOfficerInfo();
    },
    /**
     * 「選択プランクリア」ボタン押下
     */
    clearSelectedPlan: function() {
      // 選択プラン情報クリア処理
      this.planDlg.isClear = true;
      // // プラン名初期化
      // this.dispPlanIdNm = "";
      // ステップ完了状態（申込プラン）初期化
      this.isCompletedStep1 = false;
      // ステップ完了状態（役員変更）初期化
      this.isCompletedStep2 = false;
      this.planDesserts = null;
      // 登記詳細種別(役員変更 or 住所変更)
      this.officerChgAReq = false;
      this.addressChgReq = false;
      this.clearOfficerInfo();
    },
    /**
     * 役員変更入力情報クリア
     */
    clearOfficerInfo: function() {
      // ストアデータ初期化
      let emptyArray = [];
      this.$store.dispatch('requestRegInfo/setOfficerOthersList', emptyArray);
      this.$store.dispatch('requestRegInfo/setOthersDate', "");
      this.$store.dispatch('requestRegInfo/setOfficerAppointList', emptyArray);
      this.$store.dispatch('requestRegInfo/setOfficerResignList', emptyArray);
      this.$store.dispatch('requestRegInfo/setAppointDate', "");
      this.$store.dispatch('requestRegInfo/setResignDate', "");
    },
    /**
     * プラン名表示
     */
    dispSelectedPlanNames: function() {
      // 選択プランIDリスト取得(ストア)
      let selectedPlanIdList = this.$store.getters["requestRegInfo/getSelectedPlanIdList"];

      // // 表示用申込プラン情報生成
      // let planNmName = Utils.getPlanInfoForDisp(this.planMstList, selectedPlanIdList);
      // this.dispPlanIdNm = planNmName;

      // 選択プラン表示処理
      // this.dispSelectPlan(selectedPlanIdList);
      this.dispSelectPlanPriceList(selectedPlanIdList);
      // プラン料金表表示
      this.showPlanPriceList = true;

      // ステップ完了状態（申込プラン）設定
      if (selectedPlanIdList.length != 0) {
        // 完了
        this.isCompletedStep1 = true;
      } else {
        // 未完
        this.isCompletedStep1 = false;
      }
    },
    checkOfficerChgTyp: function() {

    },
    
    // // **********************************
    // //  登記ファイル（ステップ2）
    // // **********************************
    // /**
    //  * 「登記ファイル」選択内容変更
    //  */
    // changeFileInfo: function(file) {
    //   // ステップ完了状態（登記ファイル）設定
    //   if (file == null || file == undefined) {
    //     // 登記情報ファイル情報取得(ストア)
    //     let selectedFileInfo = this.$store.getters["requestRegInfo/getRegistFileInfo"];

    //     // 登記情報ファイル情報取得(ストア)に登録されている情報が無いなら未完にする。
    //     if (selectedFileInfo == null || selectedFileInfo == undefined) {
    //       // 未完
    //       this.isCompletedStep2 = false;
    //     }

    //     this.fileData = selectedFileInfo;
    //   } else {
    //     // 選択ファイル情報ストア登録
    //     this.$store.dispatch("requestRegInfo/setRegistFileInfo", file);
    //     // 完了
    //     this.isCompletedStep2 = true;
    //   }
    // },
    // /**
    //  * 「ファイル名」選択
    //  *  ファイルチューザーを起動する前にファイルデータを空にする。
    //  */
    // handleClickAppendProcess() {
    //   this.fileData = null;
    // },
    // /**
    //  * 「ファイル選択」ボタン押下
    //  * 「ファイル選択」ボタン押下をトリガーにv-fileの選択ボタンを押下する。
    //  */
    // handleClickAppendOuter() {
    //   this.fileData = null;
    //   this.$refs.vFileInput.$el.querySelector("input").click();
    // },
    // /**
    //  * 「ファイル選択クリア」ボタンクリック
    //  */
    // clearFileInfo() {
    //   // 選択ファイル情報ストアをクリア
    //   this.$store.dispatch("requestRegInfo/setRegistFileInfo", null);
    //   // ステップ完了状態（登記ファイル）初期化
    //   this.isCompletedStep2 = false;
    // },


    // **********************************
    //  役員変更（ステップ2）
    // **********************************
    /**
     * 「就任・重任(再任)」ボタン押下
     */
    changeOfficerAppoint: function() {
      
      this.officerAppointDlg.inputTyp = Constants.INPUT_TYP_APPOINT;
      this.officerAppointDlg.isOpen = true;
    },
    /**
     * 「辞任・任期満了退任・死亡・解任」ボタン押下
     */
    changeOfficerResign: function() {
      console.log(Constants.INPUT_TYP_RESIGN);
      this.officerResignDlg.inputTyp = Constants.INPUT_TYP_RESIGN;
      this.officerResignDlg.isOpen = true;
    },
    /**
     * 「代表者住所変更」ボタン押下
     */
    changeOfficerAddress: function() {
      this.officerAddressDlg.inputTyp = Constants.INPUT_TYP_ADDRESS;
      this.officerAddressDlg.isOpen = true;
    },
    /**
     * 役員変更入力情報チェック
     */
    checkOfficerInfo: function() {
      // ステップ完了状態（役員変更）チェック
      // 役員変更ストアデータ取得
      // let arrOfficer = this.$store.getters["requestRegInfo/getOfficerList"];

      let arrOfficer = null;
      let saveAppointDataArry = this.$store.getters['requestRegInfo/getOfficerAppointList'];
      let saveResignDataArry = this.$store.getters['requestRegInfo/getOfficerResignList'];
      let saveOthersDataArry = this.$store.getters['requestRegInfo/getOfficerOthersList'];
      if (this.officerChgAReq) {
        arrOfficer = saveAppointDataArry.concat(saveResignDataArry);
      } else if(this.addressChgReq) {
        arrOfficer = saveOthersDataArry;
      }

      // ステップ完了状態（役員変更）設定
      if (arrOfficer == null | arrOfficer.length == 0) {
        // 未完
        this.isCompletedStep2 = false;
        // this.isCompletedStep3 = false;
      } else {
        let cmpFlg = false;
        let officer = null;
        for (officer of arrOfficer) {
          if (officer.officerNm != "" && officer.name != "" && officer.reason.cd != "") {
          // if (officer.officerNm != "" && officer.name != "" && officer.reason.cd != "" && officer.detailInfo != "") {
            // 完了
            cmpFlg = true;
            break;
          }
        }
        // ステップ完了状態（役員変更）設定
        this.isCompletedStep2 = cmpFlg;
        // this.isCompletedStep3 = cmpFlg;
      }
    },


    // // **********************************
    // //  登記変更詳細情報（ステップ4）
    // // **********************************
    // /**
    //  * 「登記変更詳細情報」入力テキストエリア フォーカス移動
    //  */
    // setRegDetailInfo: function(e) {
    //   // 登記変更詳細情報ストア登録
    //   this.$store.dispatch("requestRegInfo/setRegChgInfoInput", e.target.value);
    //   // 登記変更詳細情報入力チェック(差分比較)
    //   let inputVal = this.comregDetail.replace(/\r?\n/g, "");
    //   let defVal = this.comregDetailDef.replace(/\r?\n/g, "");
    //   // ステップ完了状態（登記変更詳細情報）設定
    //   if (inputVal == defVal || inputVal.trim() == "") {
    //     // 未完
    //     this.isCompletedStep4 = false;
    //     if (inputVal == "") {
    //       this.comregDetail = this.comregDetailDef;
    //     }
    //   } else {
    //     // 完了
    //     this.isCompletedStep4 = true;
    //   }
    // },

    // **********************************
    //  申込み（ステップ3）
    // **********************************
    /**
     * 「お申込み確定」ボタン押下
     */
    confirmRequest: function() {
      // 選択プランIDリスト取得(ストア)
      // let selectedPlanIdList = this.$store.getters["requestRegInfo/getSelectedPlanIdList"];
      // 入力値チェック
      // if (this.isCompletedStep2 === false) {
      //   // ファイル未選択
      //   if (selectedPlanIdList.indexOf('BS00010') >= 0) {
      //     this.isCompletedStep2 = true;
      //   }
      // }
      // ステップ完了状態チェック
      if (this.isCompletedStep1 === false || this.isCompletedStep2 === false ) {
      // if (this.isCompletedStep1 === false || this.isCompletedStep2 === false || this.isCompletedStep3 === false || this.isCompletedStep4 === false) {
          // 未入力ステップあり（エラーメッセージ表示）
          this.dlgMsg.msg = this.$i18n.t('msg.err.cm020', ['ステップ1 ～ 2のお申込み内容']);
          this.dlgMsg.isOpen = true;
          this.isCompletedStep3 = false;
          // this.isCompletedStep5 = false;
          return;
      } 
      // else {
      //     if (this.isCompletedStep1 === false || this.isCompletedStep3 === false || this.isCompletedStep4 === false) {
      //       // 未入力ステップあり（エラーメッセージ表示）
      //       this.dlgMsg.msg = this.$i18n.t('msg.err.cm020', ['ステップ1 ～ 4のお申込み内容']);
      //       this.dlgMsg.isOpen = true;
      //       this.isCompletedStep5 = false;
      //       return;
      //     }
      // } 
      // 編集状態チェック
      let editStatus = this.$store.getters["requestRegInfo/getEditStatus"];
      if (editStatus != Constants.EDIT_STATUS_INPUT && editStatus != Constants.EDIT_STATUS_CONFIRM) {
        // 編集状態不正（エラーメッセージ表示）
        this.dlgMsg.msg = this.$i18n.t('webmsg.mbr100.datatblenodata');
        this.dlgMsg.isOpen = true;
        return;
      }
      this.screanLeaveFlg = true;
      // ステップ完了状態（確定）設定
      this.isCompletedStep3 = true;
      // this.isCompletedStep5 = true;
      // 役員変更ストア登録
      this.createRegisterOfficerInfo();
      // 編集状態(確定)ストア登録
      this.$store.dispatch("requestRegInfo/setEditStatus", Constants.EDIT_STATUS_CONFIRM);
      // 依頼内容確認画面へ遷移
      this.$router.push(this.$router.resolve({ name: "MBR510" }).href);
    },
    createRegisterOfficerInfo: function() {
      let officerList = [];
      let officerInfo = null;
      if (this.officerChgAReq) {
        let appointList = this.$store.getters['requestRegInfo/getOfficerAppointList'];
        let resignList = this.$store.getters['requestRegInfo/getOfficerResignList'];
        for (officerInfo of appointList) {
          if (officerInfo.officer.cd != "" && officerInfo.officer.cd != null) {
            officerList.push(Object.assign({}, officerInfo));
          }
        }
        for (officerInfo of resignList) {
          if (officerInfo.officer.cd != "" && officerInfo.officer.cd != null) {
            officerList.push(Object.assign({}, officerInfo));
          }
        }
      } else if (this.addressChgReq) {
        let othersList = this.$store.getters['requestRegInfo/getOfficerOthersList'];
        for (officerInfo of othersList) {
          if (officerInfo.officer.cd != "" && officerInfo.officer.cd != null) {
            officerList.push(Object.assign({}, officerInfo));
          }
        }
      }
      let listRowNo = 0;
      let officer;
      for (officer of officerList) {
        listRowNo = listRowNo + 1;
        officer.no = listRowNo;
      }
      this.$store.dispatch('requestRegInfo/setOfficerList', officerList);
    },

    // **********************************
    //  その他
    // **********************************
    /**
     * 「キャンセル」ボタン押下
     */
    cancel: function() {
      this.dlgMsgCanel.msg = this.$i18n.t('msg.wrn.mb010');
      this.dlgMsgCanel.isOpen = true;
    },

    /**
     * 選択プラン明細表示処理
     */
    dispSelectPlanPriceList: function(selectedPlanIdList) {
      // 消費税
      let taxInfo = this.$store.getters["master/getTaxRateKbn"];
      let taxRate = Number(taxInfo['value3']);
      this.planDesserts = new Array();
      let planPrice = null;
      let calcRewardSubTotal = 0;
      let calcTaxSubTotal = 0;
      let calcTotal = 0;
      let calcTaxTotal = 0;
      let billAmount = 0;

      this.officerChgAReq = false;
      this.addressChgReq = false;
      for (const selectedPlanCd of selectedPlanIdList) {
        if (Utils.isNullOrEmptyOrUunDef(selectedPlanCd)) {
          continue;
        }
        let searchArry = this.planMstList.find((v) => v.planCd === selectedPlanCd);
        if (searchArry == null) {
          continue;
        }

        planPrice = {};
        planPrice['planName'] = searchArry.name;
        planPrice['planReward'] = Number(searchArry.price);
        planPrice['planTax'] = Number(searchArry.supplInfo1);
        this.planDesserts.push(planPrice);

        calcRewardSubTotal += planPrice['planReward'];
        calcTaxSubTotal +=  planPrice['planTax'];

        if (searchArry.regDetailTyp === '02') {
          this.officerChgAReq = true;
        } else if (searchArry.regDetailTyp === '04') {
          this.addressChgReq = true;
        }
      }
      // 小計
      planPrice = {};
      planPrice['planName'] = "小計";
      planPrice['planReward'] = calcRewardSubTotal;
      planPrice['planTax'] = calcTaxSubTotal;
      this.planDesserts.push(planPrice);
      // 合計
      calcTotal = calcRewardSubTotal + calcTaxSubTotal;
      planPrice = {};
      planPrice['planName'] = "合計";
      planPrice['planReward'] = calcTotal;
      planPrice['planTax'] = "";
      this.planDesserts.push(planPrice);
      // 消費税
      calcTaxTotal = calcRewardSubTotal * taxRate;
      planPrice = {};
      planPrice['planName'] = taxInfo['name'];
      planPrice['planReward'] = calcTaxTotal;
      planPrice['planTax'] = "";
      this.planDesserts.push(planPrice);
      // 請求金額
      billAmount = calcTotal + calcTaxTotal;
      planPrice = {};
      planPrice['planName'] = "請求金額";
      planPrice['planReward'] = billAmount;
      planPrice['planTax'] = "";
      this.planDesserts.push(planPrice);
    },

    // /**
    //  * 選択プラン表示処理
    //  */
    // dispSelectPlan: function(selectedPlanIdList) {
    //   // 選択プラン表示
    //   this.planDesserts = new Array();
    //   let requestPlan = {};
    //   let calcTotalPrice = 0;
    //   let calcTotalTax = 0;
    //   for (const selectedPlanCd of selectedPlanIdList) {
    //     if (Utils.isNullOrEmptyOrUunDef(selectedPlanCd)) {
    //       continue;
    //     }
    //     let searchArry = this.planMstList.find((v) => v.planCd === selectedPlanCd);
    //     if (searchArry == null) {
    //       continue;
    //     }
    //     requestPlan = {};
    //     requestPlan['name'] = searchArry.name;
    //     requestPlan['price'] = `\\${searchArry.price}`;
    //     calcTotalPrice += Number(searchArry.price);
    //     calcTotalTax += Number(searchArry.supplInfo1);
    //     this.planDesserts.push(requestPlan);
    //   }

    //   // 登録免許税
    //   requestPlan = {};
    //   requestPlan['name'] = "登録免許税";
    //   requestPlan['price'] = `\\${calcTotalTax}`;
    //   this.planDesserts.push(requestPlan);

    //   // 消費税
    //   requestPlan = {};
    //   requestPlan['name'] = "消費税";
    //   requestPlan['price'] = "";
    //   this.planDesserts.push(requestPlan);

    //   // 合計計算
    //   calcTotalPrice = Math.floor((calcTotalPrice * Constants.CONSUMPTION_TAX) + calcTotalTax);
    //   this.totalAmount = `\\${calcTotalPrice}`;
    // }
  },
};
</script>

<style scoped>


.left-margin {
  margin-left: 25px;
}


/* v-file-input */
.file-input {
  margin-left: 30px;
  margin-top: 25px;
  margin-right: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
}

/* box2の選択ボタン */
.sentaku-btn2 {
  margin-bottom: 30px;
}



/* 役員情報入力横の必須マーク */
div.required:before {
  padding: 7px 6px 7px 6px;
  border-radius: 4px;
  font-size: 0.9em;
  font-weight: bold;
  color: white;
  background-color: #ff0000;
  content: "必須";
}

/* .border-row {
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #fff;
}
.table-title {
  background-color: #f2f2f2;
  width: 20%;
  font-size: 0.9em !important;
  text-align: left;
} */
@media screen and (max-width: 750px) {


  .kakutei {
    width: 10px;
    height: 20px;
  }
}

@media screen and (max-width: 1000px) {

  .kakutei {
    width: 10px;
    height: 20px;
  }
}
</style>
